// Mirrors backend App\Enums\AvailabilityType

export type AvailabilityType = 'date_specific' | 'regular' | 'holiday' | 'special'

export const AvailabilityType = {
  DATE_SPECIFIC: 'date_specific',
  REGULAR: 'regular',
  HOLIDAY: 'holiday',
  SPECIAL: 'special'
} satisfies Record<string, AvailabilityType>

export const AvailabilityTypeValues: readonly AvailabilityType[] = Object.values(AvailabilityType)
